<form [formGroup]="formGroup" class="trunk-control-test">
  @if (pageTitle) {
    <div class="trunk-control-test-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="trunk-control-test-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "radiogroup") {
      <div class="trunk-control-test-row">
        <div class="trunk-control-test-q">
          <div class="trunk-control-test-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="trunk-control-test-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="trunk-control-test-group">
          @for (choice of element.choices; track choice.value) {
            <label class="trunk-control-test-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span class="trunk-control-test-option-text">{{
                choice.text
              }}</span>
            </label>
          }
        </div>
      </div>
    }
    @if (isTotalScoreElement(element)) {
      <div class="trunk-control-test-total">
        <div class="trunk-control-test-total-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="trunk-control-test-total-score">
          {{ getScoreDisplay() }} / {{ maxScore }}
        </div>
      </div>
    }
  }
</form>
